export default function makeCrudRoutes({
  contentType,
  components: { EditContainer, GridContainer },
}) {
  return [
    {
      name: contentType.name,
      path: `/${contentType.name}/list`,
      component: GridContainer,
      props: {
        contentType,
      },
      meta: {
        authRequired: true,
        breadcrumb: [
          { title: 'Home', route: '/home' },
          { title: 'Kiosks', route: '/Kiosks' },
          { title: contentType.label, route: `/${contentType.name}/list` },
        ],
      },
    },
    {
      path: `/${contentType.name}/new`,
      component: EditContainer,
      props: {
        contentType,
      },
      meta: {
        authRequired: true,
        breadcrumb: [
          { title: 'Home', route: '/home' },
          { title: 'Kiosks', route: '/Kiosks' },
          { title: contentType.label, route: `/${contentType.name}/list` },
          { title: `New ${contentType.name}`, route: `/${contentType.name}/new` },
        ],
      },
    },
    {
      path: `/${contentType.name}/:id/edit`,
      component: EditContainer,
      props: (route) => ({ contentType, id: route.params.id }),
      meta: {
        authRequired: true,
        breadcrumb: [
          { title: 'Home', route: '/home' },
          { title: 'Kiosks', route: '/Kiosks' },
          { title: contentType.label, route: `/${contentType.name}/list` },
          { title: `Edit ${contentType.name}`, route: `/${contentType.name}/:id/edit` },
        ],
      },
    },
  ]
}
